<template>
  <div class="o-card">
    <ul class="c-list">
      <li
        v-if="!hideCalculate"
        class="c-list__item c-list__item--flex-1 u-background-color-warning"
      >
        <span class="u-color-white">
          {{ $t("projectDetail.calculateCycle") }}
        </span>
        <router-link
          :to="{
            name: 'new-cycle',
            query: {
              projectId: project.id || null,
              mainProjectId: project.mainProjectInfo?.id || null,
              seriesId: project.mainProjectInfo?.seriesInfo?.id || null,
            },
          }"
        >
          <Button variant="light-warning">
            {{ $t("common.calculate") }}
          </Button>
        </router-link>
      </li>
      <li class="c-list__item c-list__item--flex-1">
        <span> {{ $t("project.model") }} </span>
        <span> {{ project.model }} </span>
      </li>
      <li class="c-list__item c-list__item--flex-1">
        <span> {{ $t("authority.Refrigerants.mainTitle") }} </span>
        <span> {{ project.refrigerantInfo.title }} </span>
      </li>
      <li class="c-list__item c-list__item--flex-1">
        <span> {{ $t("project.compressorBrands") }} </span>
        <span> {{ project.compressorBrandInfo.title }} </span>
      </li>
      <!-- <li class="c-list__item c-list__item--flex-1">
        <span> {{ $t("project.compressorBrandRefrigerants") }} </span>
        <span> {{ project.compressorBrandRefrigerantInfo.title }} </span>
      </li> -->
      <li class="c-list__item c-list__item--flex-1">
        <span> {{ $t("project.compressorRefrigerantModel") }} </span>
        <span> {{ project.compressorRefrigerantModelInfo.title }} </span>
      </li>
      <li class="c-list__item c-list__item--flex-1">
        <span> {{ $t("project.compressorCount") }} </span>
        <span>
          {{ project.compressorCount.value }} {{ $t("common.pcs") }}
        </span>
      </li>
      <ul class="c-list" v-for="(battery, i) in project.batteryInfo" :key="i">
        <li class="c-list__item c-list__item--flex-1">
          <span>
            <chip
              class="u-margin-right-xsmall"
              size="sm"
              :variant="
                battery.isDelete
                  ? 'warning'
                  : battery.isLocked
                  ? 'danger'
                  : 'success'
              "
            >
              <i
                :class="`icofont-${
                  battery.isDelete
                    ? 'warning'
                    : battery.isLocked
                    ? 'ui-lock'
                    : 'ui-unlock'
                }`"
              ></i>
            </chip>
            <span v-if="battery.type === BatteryType.Evaporator">
              {{ $t("cyclesForm.evaporator") }}
            </span>
            <span v-if="battery.type === BatteryType.Condenser">
              {{ $t("cyclesForm.condenser") }}
            </span>
          </span>

          <router-link
            class="u-color-inherit"
            :to="{ name: 'batteries-detail', params: { id: battery.id } }"
          >
            {{ battery.name }}
          </router-link>
        </li>
        <li class="c-list__item c-list__item--flex-1">
          <span v-if="battery.type === BatteryType.Evaporator">
            {{ $t("project.evaporatorAirFlow") }}
          </span>
          <span v-if="battery.type === BatteryType.Condenser">
            {{ $t("project.condenserAirFlow") }}
          </span>
          <span> {{ battery.airflow }} m³/h </span>
        </li>
        <li
          class="c-list__item c-list__item--flex-1"
          v-if="battery.type === BatteryType.Condenser"
        >
          <span> {{ $t("project.condenserCount") }} </span>
          <span> {{ battery.count }} {{ $t("common.pcs") }}</span>
        </li>
        <li
          class="c-list__item c-list__item--flex-1"
          v-if="battery.type === BatteryType.Evaporator"
        >
          <span> {{ $t("project.superheat") }} </span>
          <span> {{ battery.superheat }} K</span>
        </li>
        <li
          class="c-list__item c-list__item--flex-1"
          v-if="battery.type === BatteryType.Evaporator"
        >
          <span> {{ $t("project.subcooling") }} </span>
          <span> {{ battery.subcooling }} K</span>
        </li>
      </ul>
      <li class="c-list__item c-list__item--flex-1">
        <span> {{ $t("project.createdDate") }} </span>
        <span> {{ $date.format(project.createdDate) }} </span>
      </li>
      <li class="c-list__item c-list__item--flex-1">
        <span> {{ $t("project.updatedDate") }} </span>
        <span> {{ $date.format(project.updatedDate) }} </span>
      </li>
      <li class="c-list__item c-list__item--flex-1">
        <span> {{ $t("project.userInfo") }} </span>
        <span> {{ project.userInfo.fullname }} </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { BatteryType } from "@/enums/Battery/BatteryType";
import Chip from "../Base/Chip.vue";
import Button from "../Base/Button.vue";
export default {
  components: {
    Chip,
    Button,
  },
  name: "ProjectInfoVertical",
  props: {
    project: {
      type: Object,
    },
    hideCalculate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BatteryType,
    };
  },
};
</script>

<style></style>
